module.exports = __webpack_public_path__ + "img/263.253d2f2a.jpg";